import { Input } from "./ui/input";
import { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Check } from "lucide-react";
import { api } from "../lib/api";

const Row = ({ e, onSaved }) => {
  const [v, setV] = useState("");
  const save = async () => {
    if (!v) return;
    try { await api.setIqamaExpiry(e.id, v); toast.success(`تم حفظ تاريخ إقامة ${e.name}`); onSaved(); }
    catch (er) { toast.error(er?.response?.data?.detail || "تعذّر الحفظ"); }
  };
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 text-sm" data-testid={`miq-row-${e.id}`}>
      <span className="font-semibold text-slate-800">{e.name}{e.branch && <span className="ms-1 text-[11px] font-normal text-slate-400">{e.branch}</span>}</span>
      <span className="flex items-center gap-1.5">
        <Input type="date" value={v} onChange={(x) => setV(x.target.value)} className="h-8 w-36 text-xs" data-testid={`miq-date-${e.id}`} />
        <button onClick={save} disabled={!v} className="rounded-lg bg-emerald-600 p-1.5 text-white disabled:opacity-40" data-testid={`miq-save-${e.id}`}><Check className="h-4 w-4" /></button>
      </span>
    </div>
  );
};

export const MissingIqama = ({ items, onSaved }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50/60" data-testid="missing-iqama">
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between gap-2 p-3 text-start text-sm text-amber-800" data-testid="missing-iqama-toggle">
        <span className="flex items-center gap-1.5"><AlertTriangle className="h-4 w-4" /> <b data-testid="missing-iqama-count">{items.length}</b> مقيم بدون تاريخ انتهاء إقامة — لن يظهروا في التوقّع</span>
        <span className="text-xs underline">{open ? "إخفاء" : "عرض وتعبئة"}</span>
      </button>
      {open && <div className="max-h-72 divide-y divide-amber-100 overflow-y-auto border-t border-amber-200 bg-white">{items.map((e) => <Row key={e.id} e={e} onSaved={onSaved} />)}</div>}
    </div>
  );
};
